"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var TransactionSummary_1 = __importDefault(require("./TransactionSummary"));
var TransactionHeader = function (_a) {
    var _b, _c, _d;
    var serviceStat = _a.serviceStat, transactions = _a.transactions, activateCurrencySource = _a.activateCurrencySource, activateDecimal = _a.activateDecimal, decimalBtnOnClick = _a.decimalBtnOnClick, currencyBtnOnClick = _a.currencyBtnOnClick;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { brand: serviceStat.service, size: "xl" }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ ml: 2, width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, noWrap: true }, { children: ((_b = serviceStat.service) === null || _b === void 0 ? void 0 : _b.niceName) || serviceStat.service.name })), (0, jsx_runtime_1.jsx)(TransactionSummary_1.default, { totalSpend: (0, end2end_1.calculateTotalSpend)(serviceStat), totalTransactions: transactions, startDate: (_c = serviceStat.oldestTransactionDate) === null || _c === void 0 ? void 0 : _c.toDate(), endDate: (_d = serviceStat.newestTransactionDate) === null || _d === void 0 ? void 0 : _d.toDate(), activateCurrencySource: activateCurrencySource, activateDecimal: activateDecimal, currencyBtnOnClick: currencyBtnOnClick, decimalBtnOnClick: decimalBtnOnClick })] }))] })));
};
exports.default = TransactionHeader;
